module.exports = __webpack_public_path__ + "static/12-745ce7764adfc1aa73da41970cd37f4d.jpg";